import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1897a50c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = {
  key: 0,
  class: "loader"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "me-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_10 = {
  class: "badge-light-primary badge me-3",
  style: {"font-size":"13px","padding-top":"14px","padding-bottom":"14px"}
}
const _hoisted_11 = {
  key: 0,
  class: "selected-count mt-2"
}
const _hoisted_12 = { class: "badge badge-primary" }
const _hoisted_13 = { style: {"font-size":"14px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1))
const _hoisted_15 = { class: "card-toolbar" }
const _hoisted_16 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_17 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_customers_export_modal"
}
const _hoisted_18 = { class: "svg-icon svg-icon-2" }
const _hoisted_19 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_20 = ["value"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "indicator-label" }
const _hoisted_23 = { class: "indicator-progress" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_25 = { class: "card-body pt-0" }
const _hoisted_26 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_27 = ["disabled", "value"]
const _hoisted_28 = { class: "badge-light-info badge" }
const _hoisted_29 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_30 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "svg-icon svg-icon-3" }
const _hoisted_33 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_34 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4",
  "data-kt-menu": "true"
}
const _hoisted_35 = { class: "menu-item px-3 me-1" }
const _hoisted_36 = { class: "menu-item px-3 me-1" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "svg-icon svg-icon-3" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ShipmentsFilter = _resolveComponent("ShipmentsFilter")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'hubs-shipments'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.printLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                disabled: _ctx.loading,
                type: "button",
                class: "btn btn-flex btn-light btn-active-primary fw-bolder me-3",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-start",
                "data-kt-menu-flip": "top-end"
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen031.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.translate('filter')), 1)
              ], 8, _hoisted_8),
              _createVNode(_component_ShipmentsFilter, {
                onTypeSelected: _ctx.onTypeChange,
                onReset: _ctx.onReset
              }, null, 8, ["onTypeSelected", "onReset"]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.tableData.length) + " out of " + _toDisplayString(_ctx.totalItems), 1)
            ]),
            (_ctx.statuses.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.selectedCount) + " " + _toDisplayString(_ctx.selectedCount === 1 ? 'Shipment' : 'Shipments'), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_vue3_json_excel, {
                "json-data": _ctx.excelData,
                fields: _ctx.excelHeader,
                worksheet: "shipments WorkSheet",
                name: "shipments.xls"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr078.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('Export Shipments')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["json-data", "fields"]),
              _createElementVNode("div", null, [
                _createVNode(_component_Form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "statusId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.statusId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statusId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.translate('selectStatus')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentStatuses, (shipmentStatus) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: shipmentStatus.id,
                            value: shipmentStatus.id
                          }, _toDisplayString(shipmentStatus.internal[1].title), 9, _hoisted_20))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("button", {
                type: "button",
                ref: "bulkApproveButton",
                class: "btn btn-primary ms-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeStatus && _ctx.changeStatus(...args))),
                disabled: !_ctx.statuses.length || !_ctx.statusId.length
              }, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate('changeStatus')), 1),
                _createElementVNode("span", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_24
                ])
              ], 8, _hoisted_21)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 100,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-checkbox": _withCtx(({ row: shipment }) => [
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  disabled: !shipment.isEditable,
                  class: "form-check-input",
                  type: "checkbox",
                  value: shipment.id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statuses) = $event))
                }, null, 8, _hoisted_27), [
                  [_vModelCheckbox, _ctx.statuses]
                ])
              ])
            ]),
            "cell-tracknumber": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.tracknumber), 1)
            ]),
            "cell-eventDate": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.eventDate), 1)
            ]),
            "cell-Captain": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.Captain?.fullName), 1)
            ]),
            "cell-officeName": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.officeName), 1)
            ]),
            "cell-eventTime": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.eventTime), 1)
            ]),
            "cell-hubName": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.hubName), 1)
            ]),
            "cell-numberOfPackages": _withCtx(({ row: shipment }) => [
              _createTextVNode(_toDisplayString(shipment.numberOfPackages), 1)
            ]),
            "cell-status": _withCtx(({ row: shipment }) => [
              _createElementVNode("span", _hoisted_28, _toDisplayString(shipment.status), 1)
            ]),
            "cell-isActive": _withCtx(({ row: shipment }) => [
              (shipment.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: shipment }) => [
              _createElementVNode("button", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end",
                onClick: ($event: any) => (_ctx.printPackages(shipment))
              }, [
                _createElementVNode("span", _hoisted_32, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr078.svg" })
                ]),
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
                ])
              ], 8, _hoisted_31),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_vue3_json_excel, {
                    class: "menu-link px-3",
                    fields: _ctx.packagesHeader,
                    "json-data": shipment.packageData,
                    worksheet: "packages WorkSheet",
                    name: "packages.xls"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Export ")
                    ]),
                    _: 2
                  }, 1032, ["fields", "json-data"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "menu-link px-3",
                    onClick: _withModifiers(($event: any) => (_ctx.printBtn(shipment)), ["prevent"])
                  }, " Print ", 8, _hoisted_37)
                ])
              ]),
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editShipment(shipment.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_39, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_38),
              (_ctx.can('remove', 'hubs-shipments'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: _normalizeClass([_ctx.disClass(shipment.isEditable), "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"]),
                    onClick: _withModifiers(($event: any) => (_ctx.deleteShipment(shipment.id)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_41, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                    ])
                  ], 10, _hoisted_40))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}